'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.images = exports.text = exports.chart = undefined;

var _draftJs = require('draft-js');

var chart = {
	type: 'chart',
	title: 'Chart Title',
	chartType: '',
	description: '',
	dataPoints: [],
	groupBy: [],
	filters: []
};

var text = {
	type: 'text',
	editorState: (0, _draftJs.convertToRaw)(_draftJs.EditorState.createEmpty().getCurrentContent()),
	data: '  '
};

var images = {
	type: 'images',
	title: 'Images Title',
	images: []
};

exports.chart = chart;
exports.text = text;
exports.images = images;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ComponentPrototypes.js
// module id = 575
// module chunks = 0